<template>
    <div class="page-main" :style="dataDetailStyle">
        <dt-search-bar style="padding:20px 5px 5px;">
            <template slot="filterSlot" v-if="form=='school'">
                <data-filter
                        ref="dataFilterRef"
                        :timeData="timeData"
                        :schoolId="schoolId"
                        :contentObject="contentObject"
                        :buttonColor="'#00CAAF'"
                        @filter-data="filterData"
                ></data-filter>
            </template>
            <template slot="buttonSlot">
                <div style="display: flex;float: right;">
                    <!--搜索框-->
                    <div class="big-data-search-input">
                        <input :placeholder="form=='school'?from=='stu'?'支持学生名称关键字搜索':'支持教师名称关键字搜索':'支持学校关键字搜索'"
                               class="big-data-input-cla" v-model="listFilters.keyWord"
                               v-on:keyup.enter="handleSearch"/>
                        <div class="big-data-search-btn" v-on:click="handleSearch">
                            <div class="big-data-search-icon">
                                <img src="../../../assets/images/databoard/detailPage/search.png" width="100%"
                                     height="100%"/>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </dt-search-bar>
        <div class="table-main-wrap" ref="tableMainRef" v-if="!isLoading">
            <div class="table-main" v-if="actionList.length>0">
                    <template v-for="(item,index) in actionList">
                        <div style="display: flex;" v-if="index==0" class="thead-th">
                            <template v-for="(subItem,subIndex) in item.codingList">
                                <div v-if="subIndex==0" class="table-thead ta-head" :class="form=='school'?'':length>6?'school-head':'school-table-thead'" :style="{width:thWidth}">
                                    <span>{{form=='school'?from=='stu'?'学生':'教师':'学校'}}</span>
                                </div>
                                <div class="table-thead ta-head" :class="form=='school'?'':length>6?'school-head':'school-table-thead'" :style="{width:thWidth}">
                                    <span>{{subItem.cls_name}}</span>
                                </div>
                            </template>
                        </div>
                        <div class="content-th" :class="index%2==0?'even-th':'odd-th'" :style="form=='region'?{lineHeight:'50px'}:''">
                            <template v-for="(subitem,subindex) in item.codingList">
                                <div v-if="subindex==0" class="table-thead text-area" :class="form=='school'?'ta-head':length>6?'school-head school-name':'school-table-thead school-name'" :style="{width:thWidth}"
                                @click="lookSchoolActionDetails(item.school_id,item.school_name)" :title="form=='school'?item.full_name:item.school_name">
                                    {{form=='school'?item.full_name:item.school_name}}
                                </div>
                                <div class="table-thead" :class="form=='school'?'ta-head':length>6?'school-head':'school-table-thead'" :style="{width:thWidth}">{{subitem.operation_count}}
                                </div>
                            </template>
                        </div>
                    </template>
            </div>
            <div class="no-data" v-else>
                <div class="">暂无数据</div>
            </div>
            <div class="bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1" show-total></Page>
                </div>
            </div>
        </div>
        <Spin size="large" class="spin-load" v-if="isLoading"></Spin>
    </div>
</template>

<script>
    import {findUserActionAnalyseDetails,regionUserActionDetailsData} from "../../../service/bigDataApi.js";
    const DataFilter = () => import('../../../components/DataFilter');
    const DtSearchBar = () => import('../../../components/DtSearchBar');
    export default {
        name: "user-action-details",
        components: {
            DtSearchBar,
            DataFilter
        },
        watch: {
            'listFilters.keyWord': {
                handler(newValue, oldValue) {
                    this.handleSearch();
                },
                deep: true
            }
        },
        data() {
            return {
                //加载中
                isLoading: true,
                length: 0,
                actionList: [],
                list: [],
                schoolId: this.$route.query.schoolId,
                form: this.$route.query.form,//判断是各校还是代理商
                funcCode: this.$route.query.funcCode,
                from: this.$route.query.from,
                listFilters: {
                    keyWord: ''
                },
                filters: {},
                dataDetailStyle: {
                    height: '850px'
                },
                //动态配置搜索框中的组件是否显示
                contentObject: {
                    //是否显示时间切换按钮
                    displayTimeFilter:true
                },
                //日期集合
                timeData: [
                    {
                        key: 0,
                        value: '全部'
                    }, {
                        key: 1,
                        value: '近一周'
                    }, {
                        key: 2,
                        value: '近一月'
                    }, {
                        key: 3,
                        value: '自定义'
                    }
                ],
                thWidth: '',
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                },
                column: [],
                //全部班级列表排序参数
                tolClassDataSortArr: [
                    {
                        sortType: 'use_class_num',
                        orderType: 'desc'
                    },
                    {
                        sortType: 'class_num',
                        orderType: 'desc'
                    }
                ],
                tolClassDataOrder: 'use_class_num desc'
            }
        },
        methods: {
            /**
             * 筛选数据
             */
            filterData(filters,searchHeight) {
                this.isLoading=true;
                this.filters = filters;
                this.pageParams.page = 1;
                this.queryDataByForm();
            },
            /**
             * 获取学校行为数据
             */
            async getSchoolUserActionAnalyseDetails() {
                let _this = this;
                let params = {
                    schoolId: _this.$route.query.schoolId,
                    funcCode: _this.$route.query.funcCode,
                    from: _this.$route.query.from,
                    sTime:_this.filters.startDate,
                    eTime:_this.filters.endDate,
                    keyWord: _this.listFilters.keyWord,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findUserActionAnalyseDetails(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.isLoading=false;
                _this.actionList=[];
                if(resultData.rows.length>0){
                    _this.thWidth = 1 / (resultData.rows[0].codingList.length + 1) * 100 + '%';
                    _this.length = resultData.rows[0].codingList.length + 1;
                    _this.actionList = resultData.rows;
                    _this.pageParams.pageCount = resultData.page_count;
                    _this.pageParams.total = resultData.total_rows;
                }
            },
            /**
             * 获取代理商行为数据
             */
            async getAgentUserActionAnalyseDetails() {
                let _this = this;
                let params = {
                    agentId: _this.$store.getters.agentId,
                    funcCode: _this.$route.query.funcCode,
                    from: _this.$route.query.from,
                    keyWord: _this.listFilters.keyWord,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await regionUserActionDetailsData(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.isLoading=false;
                _this.actionList=[];
                if(resultData.rows.length>0){
                    _this.thWidth = 1 / (resultData.rows[0].codingList.length + 1) * 100 + '%';
                    _this.length = resultData.rows[0].codingList.length + 1;
                    _this.actionList = resultData.rows;
                    _this.pageParams.pageCount = resultData.page_count;
                    _this.pageParams.total = resultData.total_rows;
                }
            },
            /**
             * 翻页
             */
            handleCurrentChange(val) {
                this.isLoading=true;
                this.isLoading = true;
                this.pageParams.page = val;
                this.queryDataByForm();
            },
            /**
             * 查询
             */
            handleSearch() {
                this.isLoading = true;
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.queryDataByForm();
            },
            /**
             * 排序
             */
            sortData(sortType) {
                for (let i = 0; i < this.tolClassDataSortArr.length; i++) {
                    if (this.tolClassDataSortArr[i].sortType == sortType) {
                        this.tolClassDataSortArr[i].orderType = this.tolClassDataSortArr[i].orderType == 'desc' ? 'asc' : 'desc';
                        this.tolClassDataOrder = this.tolClassDataSortArr[i].sortType + ' ' + this.tolClassDataSortArr[i].orderType;
                    }
                }
                this.pageParams.page = 1;
                this.queryDataByForm();
            },
            /**
             * 查看学校下的具体数据
             */
            lookSchoolActionDetails(schoolId,schoolName){
                if(this.form!='school') {
                    this.$router.push({
                        name: 'useractionanalyse',
                        query: {
                            schoolId: schoolId,
                            schoolName: schoolName,
                            userState: 'teacher',
                            form: 'school',
                            isFresh:1,
                            funcCode:this.funcCode
                        }
                    })
                }
            },
            /**
             *根据form判断类型
             */
            queryDataByForm(){
                if(this.form=='school'){
                    this.getSchoolUserActionAnalyseDetails();
                }else{
                    this.getAgentUserActionAnalyseDetails();
                }
            },
            /**
             * 面包屑
             */
            setCurrentPath() {
                let currentPathArr=[];
                this.$store.commit("setCurrentPath", currentPathArr);
            }
        },
        mounted() {
            if(this.form=='region'){
                this.queryDataByForm();
            }
            this.setCurrentPath();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/detailPage";

    .big-data-search-btn {
        background: #00CAAF !important;
        color: #fff;
        border-color: #00CAAF !important;
    }

    .table-main-wrap {
        margin-top: 10px !important;
    }

    .thead-th {
        display: flex;
        background-color: #f3f7f6;
        height: 50px !important;
        font-weight: bold;
    }

    .table-thead {
        padding: 0 10px;
    }
    .ta-head{
        display: flex;
        align-items: center;
    }
    .school-table-thead{
        text-align: left;
        margin-left: 50px;
    }
    .school-head{
        text-align: left;
    }
    .school-name{
        color:#0199ff;
        cursor: pointer;
    }

    .content-th {
        display: flex;
        height: 50px !important;
        /*line-height: 50px !important;*/
    }
    .text-area {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .even-th {
        background-color: #fff !important;
    }

    .odd-th {
        background-color: #fafbfd !important;
    }

    .content-th:last-child {
        border-bottom: 1px solid #ddd;
    }

    .no-data {
        margin-top: 50px;
        height: 50px;
        line-height: 50px;
        border: 1px solid #efefef;
        font-size: 14px;
    }
</style>
<style lang="scss">
    .spin-load{
        .ivu-spin-main{
            width: 100%;
            height: 200px;
            position: relative;
        }
        .ivu-spin-dot {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
    }
</style>
